import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';

import { getDateValue } from '../../utils/date';
import { fetchStatusCommentDetails } from '../../actions/project_actions';

class CommentsForm extends React.Component {
  // static PropTypes = {
  //   comment: PropTypes.object.isRequired,
  //   statusCommentDetails: PropTypes.array.isRequired,
  //   onSubmit: PropTypes.func.isRequired,
  //   fetchStatusCommentDetails: PropTypes.func.isRequired,
  // }

  constructor (props) {
    super(props);

    this.state = {
      ...this.getInitialState(props.comment),
      statusCommentDetails: []
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  getInitialState ({
    statusForProject='',
    comment='',
    id='',
    projectId='',
  }) {
    return {
      statusForProject,
      comment,
      id,
      projectId,
    }
  }

   UNSAFE_componentWillMount() {
    this.loadInitial();
  }

  loadInitial() {
   this.props.fetchStatusCommentDetails(this.props.projectId, this.props.comment.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const statusCommentDetails = nextProps.statusCommentDetails;

    this.setState({
      statusCommentDetails: statusCommentDetails,
    });
  }

  handleChange (field) {
    return (e) => {
      this.setState({ [field]: e.target.value });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    if (this.props.comment.typeId === 1) {
      const fields = 'statusForProject,comment'.split(',');
      const values = _.pick(this.state, fields)

      if (_.every(values)) {
        this.props.onSubmit({
          ...this.props.comment,
          ...values
        });
      }
    }

    if (this.props.comment.typeId === 2) {
      const fieldsActivity = 'comment'.split(',');
      const valuesActivity = _.pick(this.state, fieldsActivity)
      if (_.every(valuesActivity)) {
        this.props.onSubmit({
          ...this.props.comment,
          ...valuesActivity
        });
      }
    }
  }

  renderTable (statusCommentDetails) {

    return (
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Comment</th>
              <th>Created By</th>
              <th>Created Date</th>
            </tr>
          </thead>
           <tbody>
          { statusCommentDetails.map(comment =>
            <tr key={comment.id}>
            <td>{comment.comment}</td>
              <td>{comment.createdUserUniqueName}</td>
              <td>{getDateValue(comment.createdDate)}</td>
            </tr>
          )}
          </tbody> 
        </table>
      </div>
    );
  }

  render () {
    const  statusCommentDetails  = this.state.statusCommentDetails;
    let canSubmit = false; 
    if(this.props.comment.typeId === 1) {
      canSubmit = (this.state.comment!==undefined && this.state.comment!=='') && (this.state.statusForProject!==undefined && this.state.statusForProject!=='') }
    else if(this.props.comment.typeId === 2) {
      canSubmit = (this.state.comment!==undefined && this.state.comment!=='') }

    return (
      <div>
        <form className="modal-form comments-form" onSubmit={this.handleSubmit}>

          {this.props.comment.typeId === 1 
           ?<div className="control required">
            <label>Status For</label>
            <input type="text" name="statusForProject"
              value={this.state.statusForProject}
              onChange={this.handleChange('statusForProject')}
              maxLength='100'
            />
          </div>
          : null}
          
           {statusCommentDetails.length
            ? <div className="control required">
              <label>Comments</label>
              <textarea name="comment" cols='3' rows='5'
              defaultValue={statusCommentDetails[0].comment}
                onChange={this.handleChange('comment')}>
              </textarea>
            </div>
            : null}        

          <button className="btn-update" disabled={!canSubmit}>Save</button>
        </form>

        <div className="project-detail-comments">
          <div className="col s12">
            {statusCommentDetails.length
              ? this.renderTable(statusCommentDetails)
              : <div>This project has no comments yet.</div>}
          </div>
        </div>

      </div>
    )
  }
}

CommentsForm.propTypes = {
  comment: PropTypes.object.isRequired,
  statusCommentDetails: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fetchStatusCommentDetails: PropTypes.func.isRequired
};

function mapStateToProps (state) {
  return {
    projectId: state.projectsStore.info.projectId,
    statusCommentDetails: state.projectsStore.statusCommentDetails
  };
}

export default connect(mapStateToProps, {fetchStatusCommentDetails})(CommentsForm);